import { SUPPLIER_EXCHANGE_RATES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/supplier_exchange_rates_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['supplierExchangeRatesIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
